import createReactComponent from '../createReactComponent';
export default createReactComponent('filter', 'Filter', [["path",{"d":"M4.5 7h15M7 12h10m-7 5h4","key":"svg-0"}]]);